import { Button, Modal } from "antd";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { FaPrint, FaRegCalendarCheck } from "react-icons/fa";
import { HiOutlineBackspace } from "react-icons/hi";
import axiosInstance from "../../../../../Components/axiosInstance/AxiosInstance";
import { useMessage } from "../../../../../Components/MessageProvider/MessageProvider";
export default function Daily() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [date, setDate] = useState(false);
  const [data, setData] = useState(null);
  const messageApi = useMessage();

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };
  let elementRef = useRef();
  const handlePrint = () => {
    const printContent = elementRef.current;
    const WinPrint = window.open("", "", "width=900,height=900");

    WinPrint.document.write(`<html>
      <head>
        <title>Print</title>
        <style>
          @media print {
            @page {
              margin: 0 10mm;
            }
            body {
              margin: 0;
              
              font-family: Arial, sans-serif;
            }
          }
        </style>
      </head>
      <body>${printContent.innerHTML}</body>
    </html>`);

    WinPrint.document.close();
    WinPrint.focus();
    WinPrint.print();
    WinPrint.close();
  };

  function formatDate(inputDate) {
    // Month names in Uzbek
    const uzbekMonths = [
      "январ",
      "феврал",
      "март",
      "апрел",
      "май",
      "июн",
      "июл",
      "август",
      "сентябр",
      "октябр",
      "ноябр",
      "декабр",
    ];

    // Split the input date (dd.mm.yyyy) into day, month, and year
    const [day, month, year] = inputDate.toString().split(".");

    // Convert to Uzbek format
    const formattedDate = `${year} йил ${parseInt(day, 10)} ${
      uzbekMonths[parseInt(month, 10) - 1]
    }`;

    return formattedDate;
  }

  let getData = async () => {
    try {
      // setLoading(true);

      let { data: info } = await axiosInstance.get(
        "/api/chiqim-official/chirchiq/daily?date_nakladnoy=" + date
      );

      console.log(info);

      if (info.success) {
        setData(info.data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      // setLoading(false);
    }
  };

  let sumOf = (val) => {
    return val.reduce((cal, curr) => {
      return cal + curr.tonna;
    }, 0);
  };
  useEffect(() => {
    getData();
  }, [date]);
  return (
    <div>
      <Button
        onClick={() => {
          setIsModalOpen(true);
        }}
        icon={<FaRegCalendarCheck />}
        size="large"
        className=" rounded-xl fixed bottom-[13%] right-[2%] z-30 bg-white"
      ></Button>

      {isModalOpen ? (
        <div
          className="absolute z-[999] top-0 h-screen w-full bottom-0 overflow-auto"
          style={{
            backgroundColor: "#FFF",
          }}
        >
          <div className="w-[100%] flex flex-row items-center justify-around p-2">
            <Button
              onClick={() => {
                handlePrint();
              }}
              variant="solid"
              icon={<FaPrint className="font-[30px]" />}
            >
              Print
            </Button>
            <input
              type="date"
              onChange={(e) => {
                console.log(moment(e.target.value).format("YYYY-MM-DD"));
                // `${moment(date).format("YYYY-MM-DD")}`
                setDate(moment(e.target.value).format("YYYY-MM-DD"));
              }}
            />
            <Button
              onClick={() => {
                setIsModalOpen(false);
              }}
              variant="solid"
              icon={<HiOutlineBackspace className="font-[30px]" />}
            ></Button>
          </div>
          <div className="max-w-[900px] w-[95%] m-auto">
            {" "}
            <div
              ref={elementRef}
              style={{
                width: "100%",
                fontSize: "16px",
                fontFamily: "times new roman bold",
                fontWeight: "bold",
                fontStyle: "normal",
              }}
            >
              <h2
                style={{
                  textAlign: "center",
                  fontSize: "14px",
                  paddingTop: "50px",
                  textDecoration: "underline",
                }}
              >
                2024 йил 4 март кунги кунги №38-5/07-OB сонли ваколатли омборда
                минерал ўғитларни сақлаш шартномасига асосан
              </h2>
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "16px",
                  fontWeight: 600,
                }}
              >
                "MINERAL - MARKET" MЧЖ № 111 - омбори{" "}
                {formatDate(moment(date).format("DD.MM.YYYY"))} чиқим қилиш
              </h3>
              <h3
                style={{
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: 600,
                }}
              >
                М А Ъ Л У М О Т Н О М А С И
              </h3>
              <p
                style={{
                  textAlign: "left",
                  fontSize: "16px",
                  fontWeight: 600,
                  paddingLeft: "15px",
                }}
              >
                <span
                  style={{
                    paddingRight: "15px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Етказиб берувчи:
                </span>{" "}
                <span
                  style={{
                    paddingLeft: "15px",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  "MAXAM-CHIRCHIQ" AJ (ИНН 200941518)
                </span>
              </p>

              {/* table here */}
              <div
                style={{
                  marginLeft: "15px",
                  marginRight: "15px",
                }}
              >
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                  }}
                  border="1"
                  className="text-[16px]"
                  cellpadding="10"
                >
                  <tr>
                    <th
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      rowspan="2"
                    >
                      №
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                      colSpan={2}
                    >
                      ЎзРТХБ шартномаси
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                      rowSpan={2}
                    >
                      Юкни олувчи номи
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      rowSpan={2}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                    >
                      СТИР
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                      rowSpan={2}
                    >
                      yukxati raqami
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                      colSpan={2}
                    >
                      Чиким килинган махсулот
                    </th>
                  </tr>
                  <tr>
                    <th
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2 border border-gray-400 px-4 py-2"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                    >
                      Шартнома №
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                    >
                      Санаси
                    </th>

                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                    >
                      Номи
                    </th>
                    <th
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-2"
                    >
                      Угит микдори (тонна)
                    </th>
                  </tr>
                  {/* <tr
                    style={{
                      fontSize: "16px",
                      margin: 0,
                    }}
                  >
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      1
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: "10px",
                        paddingLeft: "4px",
                        lineHeight: "16px",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      amafos
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Tn
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      230
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      320
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      10
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      Karbamid
                    </td>
                    <td
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                    >
                      10
                    </td>
                  </tr> */}
                  {data
                    ? data.map((el) => {
                        return (
                          <tr
                            style={{
                              fontSize: "16px",
                              margin: 0,
                            }}
                          >
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              1
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: "10px",
                                paddingLeft: "4px",
                                lineHeight: "16px",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.product}
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: 0,
                                paddingLeft: "4px",
                                lineHeight: "16px",
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              Tn
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.name}
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.INN}
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: 0,
                                paddingLeft: "4px",
                                lineHeight: "16px",
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.ykx?.ykx}
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: 0,
                                paddingLeft: "4px",
                                lineHeight: "16px",
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.product}
                            </td>
                            <td
                              style={{
                                fontSize: "16px",
                                margin: 0,
                                padding: 0,
                                paddingLeft: "4px",
                                lineHeight: "16px",
                                padding: "4px",
                                textAlign: "center",
                              }}
                              className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                            >
                              {el?.tonna}
                            </td>
                          </tr>
                        );
                      })
                    : null}

                  <tr>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      X
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                      colspan="2"
                    >
                      Жами:{" "}
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      X
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      X
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      X
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "4px",
                        textAlign: "center",
                      }}
                    >
                      X
                    </td>
                    <td
                      className="text-[16px] text-left text-bold border border-gray-400 px-4 py-1"
                      style={{
                        fontSize: "16px",
                        margin: 0,
                        padding: 0,
                        paddingLeft: "4px",
                        lineHeight: "16px",
                        padding: "10px",
                        textAlign: "center",
                      }}
                    >
                      {data ? sumOf(data) : 0}
                    </td>
                  </tr>
                </table>
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "10px",
                  // paddingTop: "30px",
                }}
              >
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                    }}
                  >
                    Юкни чиқарди сақловчи
                  </p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center ",
                      gap: "200px",
                    }}
                  >
                    <p
                      style={{
                        fontSize: "16px",
                      }}
                    >
                      "MINERAL- MARKET" МЧЖ :
                    </p>
                    <p
                      style={{
                        fontSize: "16px",
                      }}
                    >
                      ________________А.Парпиев
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
}
